import { stringify } from "../../util/querystring-util";
import { GetProjectsRequest, GetProjectsResponse } from ".";
import { restResourceRequester } from "../rest-resource-requester";

interface ProjectsRestResource {
  getProjects(request: GetProjectsRequest): Promise<GetProjectsResponse>;
}

const REST_RESOURCE_NAME = `/projects`;

/**
 * GET /get-projects
 */
const getProjects = restResourceRequester<
  GetProjectsRequest,
  GetProjectsResponse
>("GET", (request) => {
  const queryParameters = {
    pjtNameOrDesc: request.pjtNameOrDesc,
    prdDplymntDateRangFrom: request.prdDplymntDateRangFrom,
    prdDplymntDateRangTo: request.prdDplymntDateRangTo,
    stgDplymntDateRangFrom: request.stgDplymntDateRangFrom,
    stgDplymntDateRangTo: request.stgDplymntDateRangTo,
    pjtRgstrDateRangFrom: request.pjtRgstrDateRangFrom,
    pjtRgstrDateRangTo: request.pjtRgstrDateRangTo,
    pjtStsList: request.pjtStsList,
    pjtLnchTypeList: request.pjtLnchTypeList,
    dipList: request.dipList,
    userId: request.userId,
    isPmyOnly: request.isPmyOnly,
    cpntIdList: request.cpntIdList,
    pjtId: request.pjtId,
    pjtName: request.pjtName,
    dfnSetVerNum: request.dfnSetVerNum,
  };
  return `${REST_RESOURCE_NAME}?${stringify(queryParameters)}`;
});

export const projectsRestResource: ProjectsRestResource = {
  getProjects: getProjects,
};
